import React from "react";

import { useIntl } from "react-intl";

import { Button, Popconfirm } from "@mapmycustomers/ui";

import styles from "./Footer.module.scss";

interface Props {
  creating?: boolean;
  okDisabled?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
  showConfirmation?: boolean;
}

const Footer: React.FC<Props> = ({ creating, okDisabled, onCancel, onOk, showConfirmation }) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <Popconfirm
        cancelText={intl.formatMessage({
          id: "map.colorization.createEditSidebar.footer.saveConfirmation.no",
          defaultMessage: "Wait",
          description: "No button in a Save Pin Legend confirmation",
        })}
        description={intl.formatMessage(
          {
            id: "map.colorization.createEditSidebar.footer.saveConfirmation.description",
            defaultMessage: "Any changes will be visible to{br}users this legend is shared with.",
            description: "Confirmation to save changed to pin legend",
          },
          {
            br: <br />,
          }
        )}
        okText={intl.formatMessage({
          id: "map.colorization.createEditSidebar.footer.saveConfirmation.yes",
          defaultMessage: "Proceed",
          description: "Yes button in a Save Pin Legend confirmation",
        })}
        onConfirm={onOk}
        title={intl.formatMessage(
          {
            id: "map.colorization.createEditSidebar.footer.saveConfirmation.title",
            defaultMessage: "Are you sure want proceed{br}with changes to this legend?",
            description: "Confirmation to save changed to pin legend",
          },
          {
            br: <br />,
          }
        )}
        trigger={!showConfirmation || okDisabled ? [] : ["click"]}
      >
        <Button
          block
          disabled={okDisabled}
          onClick={!showConfirmation ? onOk : undefined}
          type="primary"
        >
          {intl.formatMessage(
            {
              id: "map.colorization.createEditSidebar.footer.ok",
              defaultMessage: "{creating, select, true {Save & Continue} other {Save}}",
              description: "Ok button in a Create/Edit custom pin colorization panel",
            },
            { creating }
          )}
        </Button>
      </Popconfirm>

      <Popconfirm
        cancelText={intl.formatMessage({
          id: "map.colorization.createEditSidebar.footer.cancelConfirmation.no",
          defaultMessage: "Cancel",
          description: "No button in a Cancel Pin Legend confirmation",
        })}
        description={intl.formatMessage({
          id: "map.colorization.createEditSidebar.footer.cancelConfirmation",
          defaultMessage: "All changes will be lost",
          description: "Confirmation to cancel changes to pin legend",
        })}
        okText={intl.formatMessage({
          id: "map.colorization.createEditSidebar.footer.cancelConfirmation.yes",
          defaultMessage: "Continue",
          description: "Yes button in a Cancel Pin Legend confirmation",
        })}
        onConfirm={onCancel}
        trigger={creating ? [] : ["click"]}
      >
        <Button block onClick={creating ? onCancel : undefined}>
          {intl.formatMessage({
            id: "map.colorization.createEditSidebar.footer.cancel",
            defaultMessage: "Cancel",
            description: "Cancel button in a Create/Edit custom pin colorization panel",
          })}
        </Button>
      </Popconfirm>
    </div>
  );
};

export default Footer;
